import * as angular from 'angular';
import * as _ from 'lodash';
import * as $ from 'jquery';

import { Shape, ComponentDefinition } from '../../../models';
import { Helper } from '../../../common';
import { ITranslatedLoggerService } from '../../../services';

class ShapeListController implements angular.IComponentController {
    formController: angular.IFormController;
    isLoading: boolean;
    loadingMessage: string;
    selectedShape: Shape;
    
    readonly canSelect: boolean;
    readonly onDelete: (shapes?: Shape[]) => void;
    readonly onDuplicate: (shape: Shape) => void;
    readonly shapes: Shape[];

    static $inject = ['translatedLoggerService'];

    constructor(private _logger: ITranslatedLoggerService) {
    }

    tryDelete(shape: Shape, $event: angular.IAngularEvent) {
        this.select(shape, $event);
        $('#deleteShapeModal').modal('show');
    }

    remove(guid: string) {
        const removed = _.remove(this.shapes, s => s.guid === guid);
        if (this.onDelete) {
            this.onDelete(removed);
        }
    }

    duplicate(shape: Shape, $event: angular.IAngularEvent) {
        if (this.canSelect) {
            const newShape = angular.copy(shape);
            newShape.guid = Helper.getGuid();
            this.shapes.push(newShape);
            this.selectedShape = newShape;
        } else {
            this.displayPreventSelect();
        }
        
        if ($event.stopPropagation) { 
            $event.stopPropagation();
        }
        if (this.onDuplicate) {
            this.onDuplicate(shape);
        }
    }

    select(shape: Shape, $event: angular.IAngularEvent) {
        if (this.canSelect) {
            this.selectedShape = shape;
        } else {
            this.displayPreventSelect();
        }
        if ($event.stopPropagation) {
            $event.stopPropagation();
        }
    }

    private displayPreventSelect() {
        this._logger.logWarning('Save or cancel changes before selecting another shape');
    }
}

export const wtShapeList: ComponentDefinition = {
    componentId: 'wtShapeList',
    controller: ShapeListController,
    template: require('./shapeList.component.html'),
    controllerAs: 'vm',
    bindings: {
        canSelect: '<?',
        onDelete: '&?',
        onDuplicate: '&?',
        selectedShape: '=?',
        shapes: '<'
    }
};
